import repository from '@/services/repository';

const resource = '/search';

export default {
    getSearchData(searchValue: string) {
        const payload = {searchValue, take : 20, skip : 0};
        return repository.post(`${resource}`, payload);
    },
};
